import { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      setUser(user);
      
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        // Check if user email is the admin email
        const adminEmail = 'giannisaliev@gmail.com';
        const isAdminByEmail = user.email === adminEmail;
        
        // Also check the user document in Firestore for isAdmin flag
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        const isAdminByDoc = userDoc.exists() && userDoc.data().isAdmin === true;
        
        setIsAdmin(isAdminByEmail || isAdminByDoc);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return { isAdmin, loading, user };
}
